module.exports = __webpack_public_path__ + "public/images/eagle.f4814c16bf4e095f96bb84002eb44bfa.png";